import { UserPlus } from 'lucide-react'

const OneOnOneTab = ({ oneOnOneRequests }) => {
  if (!oneOnOneRequests) return null

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-white flex items-center gap-2">
          <UserPlus className="w-6 h-6" />
          1-on-1 Booking Requests ({oneOnOneRequests.length})
        </h3>
      </div>

      {oneOnOneRequests.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <UserPlus className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No 1-on-1 booking requests yet</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-white/10">
            <thead>
              <tr>
                {['User', 'Facilitator', 'Preferred Date', 'Time', 'Topic', 'Status', 'Submitted'].map(header => (
                  <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10">
              {oneOnOneRequests.map((request) => (
                <tr key={request.id} className="hover:bg-white/5">
                  <td className="px-4 py-4">
                    <div className="text-sm font-medium text-white">{request.userProgram?.user?.name || 'N/A'}</div>
                    <div className="text-xs text-gray-400">{request.userProgram?.user?.email}</div>
                    {request.userProgram?.user?.phone && (
                      <div className="text-xs text-gray-500">{request.userProgram?.user?.phone}</div>
                    )}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-white">{request.facilitatorName}</div>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    {request.preferredDate || 'Not specified'}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300 capitalize">
                    {request.preferredTime || 'Not specified'}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-300 max-w-xs">
                    {request.topic ? (
                      <span className="truncate block" title={request.topic}>{request.topic}</span>
                    ) : (
                      <span className="text-gray-500">-</span>
                    )}
                    {request.message && (
                      <span className="text-xs text-gray-500 block truncate mt-1" title={request.message}>
                        📝 {request.message}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      request.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300' :
                      request.status === 'contacted' ? 'bg-blue-500/20 text-blue-300' :
                      request.status === 'scheduled' ? 'bg-purple-500/20 text-purple-300' :
                      request.status === 'completed' ? 'bg-green-500/20 text-green-300' :
                      'bg-red-500/20 text-red-300'
                    }`}>
                      {request.status}
                    </span>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    {new Date(request.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default OneOnOneTab
